import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import * as Cliente from "../../modelos/cliente.modelo";
import * as myGlobals from "../../modelos/globales.modelo";

declare let $: any;

@Component({
    selector: "app-home",
    templateUrl: "home.component.html",
    styleUrls: ["home.component.css"],
    standalone: false
})
export class HomeComponent implements OnInit {
  public oCliente: Cliente.cCliente = null;

  constructor(
    public oRouter: Router,
    public oRouterActivo: ActivatedRoute,
  ) {}

  ngOnInit() {
    $(".capa-cita").addClass("visible");
  }

  // Comprueba si el cliente se ha logado correctamente
  getClienteLogado(): boolean {
    return !myGlobals.isNullUndefinedVacio(localStorage.getItem("AccessToken"));
  }

  getInfoWeb(): string {
    this.oCliente = myGlobals.oClienteActivo();
    if (!myGlobals.isNullUndefined(this.oCliente)) {
      return this.oCliente.client.facebook;
    } else {
      return "";
    }
  }
}
